import createPagination from './components/paginationHandler';

export default createPagination;